import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { Label } from 'components/cards/common/CardLabel/CardLabel.styled'
import { Preview } from 'components/cards/common/CardPreview/CardPreview.styled'
import { Title } from 'components/cards/common/CardTitle/CardTitle.styled'
import { CardContainerProps } from './CardContainer'

export const Container = styled.div<CardContainerProps>`
  position: relative;

  & > div:last-child {
    margin-bottom: 0;
  }

  ${({ theme }) => `
    color: ${theme.color.black};
    background: ${theme.color.white};
    border-radius: ${theme.borderRadius.base};
    padding: ${theme.space.mobile.small} ${theme.space.mobile.base};

    ${Preview} {
      margin: -${theme.space.mobile.small} -${theme.space.mobile.base} 0;
    }

    ${Label} {
      margin-left: calc(-${theme.space.mobile.base} - 12px);
      padding-left: calc(${theme.space.mobile.base} + 12px);
    }
  `}

  ${({ theme }) => media.sm`
    padding: ${theme.space.desktop.small} ${theme.space.desktop.base};

    ${Preview} {
      margin: -${theme.space.desktop.small} -${theme.space.desktop.base} 0;
    }

    ${Label} {
      margin-left: calc(-${theme.space.desktop.base} - 12px);
      padding-left: calc(${theme.space.desktop.base} + 12px);
      max-width: calc(100% + ${theme.space.desktop.base} + 12px);
    }
  `}
  
  &:hover {
    ${Preview} {
      transform: translateY(-5px);

      img {
        transform: scale(1.05);
      }
    }

    ${Title} {
      transform: translateY(-5px);
    }
  }

  ${({ boxShadow, theme }) =>
    boxShadow &&
    `
    transition: box-shadow 0.5s ease-out;
    box-shadow: 4px 4px 0 0 ${theme.color.cornflower};

    &:hover {
      box-shadow: -4px 4px 0 0 ${theme.color.cornflower};
    }
  `}
`
